import React from 'react';
import { motion } from 'framer-motion';

const ChatTypingIndicator: React.FC = () => {
  return (
    <div className="flex space-x-2 p-3 bg-gray-100 dark:bg-gray-700 rounded-xl w-16">
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full"
          animate={{
            y: ['0%', '-50%', '0%'],
          }}
          transition={{
            duration: 0.8,
            repeat: Infinity,
            delay: i * 0.2,
          }}
        />
      ))}
    </div>
  );
};

export default ChatTypingIndicator;